import React, { useEffect, useState } from "react";
import { NavLink, Route, Routes, useLocation, Navigate } from "react-router-dom";
import TopBar from "../../../components/TopBar";
import SideBar from "../../../components/SideBar";
import "../../../styles/AdminCabinetPage.css";

import ProjectIncomePage from "./ProjectIncomePage";
import WebmastersPage from "./WebmastersPage";
import ApprovalsPage from "./ApprovalsPage";
import PayoutsPage from "./PayoutsPage";
import OfferRequestsPage from "./OfferRequestsPage";
import AdminLogsPage from "./AdminLogsPage";
import BynaTestOfferPage from "./BynaTestOfferPage";
import { SupportWorkspace } from "../support";
import NotFoundPage from "../../../components/NotFoundPage";
import { serverDomain } from "../../../config";

const AdminCabinetPage = () => {
  const location = useLocation();

  const [isAuthorized, setIsAuthorized] = useState(null);
  const [token, setToken] = useState(null);

  const [approvalsCount, setApprovalsCount] = useState(0);
  const [payoutsCount, setPayoutsCount] = useState(0);
  const [offerRequestsCount, setOfferRequestsCount] = useState(0);

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) {
      setIsAuthorized(false);
      return;
    }

    try {
      const decoded = JSON.parse(atob(t.split(".")[1]));
      if (decoded.role === "admin") {
        setIsAuthorized(true);
        setToken(t);
      } else {
        setIsAuthorized(false);
      }
    } catch (e) {
      console.error("Ошибка проверки токена:", e);
      setIsAuthorized(false);
    }
  }, []);

  const fetchPendingCounts = async (tkn) => {
    try {
      const [approvalsRes, payoutsRes, offerReqRes] = await Promise.all([
        fetch(`${serverDomain}/api/admin/approvals/pending-users`, {
          headers: { Authorization: `Bearer ${tkn}` },
        }),
        fetch(`${serverDomain}/api/admin/payouts`, {
          headers: { Authorization: `Bearer ${tkn}` },
        }),
        fetch(`${serverDomain}/api/admin/offer-requests`, {
          headers: { Authorization: `Bearer ${tkn}` },
        }),
      ]);

      if (!approvalsRes.ok || !payoutsRes.ok || !offerReqRes.ok) {
        throw new Error("Ошибка загрузки данных");
      }

      const approvalsData = await approvalsRes.json();
      const payoutsData = await payoutsRes.json();
      const offerRequestsData = await offerReqRes.json();

      setApprovalsCount((approvalsData || []).length);
      setPayoutsCount((payoutsData || []).filter((p) => p.status === "pending").length);
      setOfferRequestsCount((offerRequestsData || []).filter((r) => r.status === "pending").length);
    } catch (e) {
      console.error("Ошибка загрузки заявок:", e);
    }
  };

  // Подтягиваем счётчики при входе и при смене раздела (navigation)
  useEffect(() => {
    if (isAuthorized && token) fetchPendingCounts(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized, token, location.pathname]);

  if (isAuthorized === null) {
    return (
      <div className="loading-container">
        <div className="loader" />
      </div>
    );
  }

  if (!isAuthorized) {
    return <NotFoundPage />;
  }



  return (
    <div className="fl-admin-mode">
      <TopBar pageTitle={"Админ-кабинет"} />
      <div className="main-container">
        <SideBar />

        <main className="home-main flex-grow-1">
          <div className="fl-page fl-admin">
            <div className="fl-admin-shell">
              {/* MENU */}
              <aside className="fl-admin-menu">
                <div className="fl-admin-menu__head">
                  <div className="fl-admin-menu__title">Разделы</div>

                  <button
                    type="button"
                    className="fl-iconbtn fl-iconbtn--ghost"
                    title="Обновить счётчики"
                    onClick={() => token && fetchPendingCounts(token)}
                  >
                    ⟳
                  </button>
                </div>

                <nav className="fl-admin-nav">
                  <NavLink to="project-income" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>💰 Доход проекта</span>
                  </NavLink>

                  <NavLink to="webmasters" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>👤 Вебмастера</span>
                  </NavLink>

                  <NavLink to="approvals" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>📝 Анкеты на одобрение</span>
                    {approvalsCount > 0 ? <span className="fl-badge">{approvalsCount}</span> : null}
                  </NavLink>

                  <NavLink to="logs" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>📜 Лог операций</span>
                  </NavLink>

                  <NavLink to="offer-requests" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>📩 Заявки на оффер №3</span>
                    {offerRequestsCount > 0 ? <span className="fl-badge">{offerRequestsCount}</span> : null}
                  </NavLink>

                  <NavLink to="payouts" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>💳 Выплаты</span>
                    {payoutsCount > 0 ? <span className="fl-badge">{payoutsCount}</span> : null}
                  </NavLink>

                  <NavLink to="byna-test-offer" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>Byna.Ru · тестовый RevShare</span>
                  </NavLink>
                  <NavLink to="support" className={({ isActive }) => `fl-admin-link ${isActive ? "is-active" : ""}`}>
                    <span>Обращения поддержки</span>
                  </NavLink>
                </nav>

                <div className="fl-admin-menu__hint">
                  Бейджи показывают количество ожидающих заявок.
                </div>
              </aside>

              {/* CONTENT */}
              <section className="fl-admin-content fl-cardbox">
              <Routes>
                <Route index element={<Navigate to="project-income" replace />} />
                <Route path="project-income" element={<ProjectIncomePage />} />
                <Route path="webmasters" element={<WebmastersPage />} />
                <Route path="approvals" element={<ApprovalsPage />} />
                <Route path="logs" element={<AdminLogsPage />} />
                <Route path="payouts" element={<PayoutsPage />} />
                <Route path="offer-requests" element={<OfferRequestsPage />} />
                <Route path="byna-test-offer" element={<BynaTestOfferPage />} />
                <Route path="support" element={<SupportWorkspace admin />} />
              </Routes>
              </section>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminCabinetPage;
